/**
 * Created by filatov on 16.09.2015.
 */
import HTMLColumnsStrategy from '../HTMLColumnsStrategy'
import {LeaveTypeBalanceQualifier} from '../../../leavesReport/LeaveReportConfig'
import LeaveHTMLPreviewBothBalanceColumnsRender from './LeaveHTMLPreviewBothBalanceColumnsRender'
import LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender from './LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender'
import LeaveHTMLPreviewPTOOnlyBalanceColumnsRender from './LeaveHTMLPreviewPTOOnlyBalanceColumnsRender'

export default function LeaveHTMLPreviewBaseColumnsStrategy() {}

LeaveHTMLPreviewBaseColumnsStrategy.prototype = new HTMLColumnsStrategy();

LeaveHTMLPreviewBaseColumnsStrategy.prototype.init = function( timeFormat )
{
    HTMLColumnsStrategy.prototype.init.call( this, timeFormat );
    return this;
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowCells = function( firstHeaderRow )
{
    // abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowCells = function( secondHeaderRow )
{
    // abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function( row )
{
    //abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.getStrategyCssClass = function ()
{
    //abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.createLeaveHeaderCell = function()
{
    return ReportPreviewUtils.createCell( this.message("report.common.leave_type"), "leaveType", 1, 2 );
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.createTotalLeaveTimeCell = function ()
{
    return ReportPreviewUtils.createCell( this.message("report.leaves.total.html_csv"), "leaveTypeTotal", 1, 2 );
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype._initBalanceColumnsRenderConstructor = function(balanceQualifier, withSpaces){
    switch(balanceQualifier){
        case LeaveTypeBalanceQualifier.SICK_DAYS_ONLY : return new LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender(withSpaces)
        case LeaveTypeBalanceQualifier.PTO_ONLY : return new LeaveHTMLPreviewPTOOnlyBalanceColumnsRender(withSpaces)
        default: return new LeaveHTMLPreviewBothBalanceColumnsRender(withSpaces)
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewBaseStrategy.js